import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useMemo, useRef, useState } from 'react';
var EditPostCreateModalContext = /*#__PURE__*/createContext({
  editViewPayload: undefined,
  setEditViewPayload: function setEditViewPayload() {},
  enableEditView: function enableEditView() {},
  shouldActivateEditView: function shouldActivateEditView() {
    return false;
  }
});
export var EditPostCreateModalProvider = function EditPostCreateModalProvider(_ref) {
  var active = _ref.active,
    children = _ref.children;
  var _shouldActivateEditView = useRef(false);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    editViewPayload = _useState2[0],
    setEditViewPayload = _useState2[1];
  var value = useMemo(function () {
    return {
      editViewPayload: editViewPayload,
      setEditViewPayload: setEditViewPayload,
      enableEditView: function enableEditView(enable) {
        _shouldActivateEditView.current = enable;
      },
      shouldActivateEditView: function shouldActivateEditView() {
        return _shouldActivateEditView.current;
      }
    };
  }, [editViewPayload, setEditViewPayload]);
  if (editViewPayload && !active) {
    setEditViewPayload(undefined);
  }
  return /*#__PURE__*/React.createElement(EditPostCreateModalContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
export var useEditPostCreateModal = function useEditPostCreateModal() {
  var value = useContext(EditPostCreateModalContext);
  if (!value) {
    throw new Error('useEditPostCreateModal used outside of useEditPostCreateModalProvider');
  }
  return value;
};